<template>
  <div style="padding: 20px">
    <el-button class="mybtn-blue2" style="width: 100px" @click="addDialogVisible=true">设置</el-button>
    <hr>
    <el-row>
      <el-col :span="12">
        <div>
          <p class="subtitle">库存自动体检设置信息</p>
            <el-form label-width="130px">
              <el-form-item label="库存自动检测：">
                <span>{{autoCheck?'开启':'关闭'}}</span>
              </el-form-item>
              <el-form-item label="接收汇报结果：">
                <span>{{receiveResult_text()}}</span>
              </el-form-item>
              <el-form-item label="检测范围：">
                <span>{{scope_text()}}</span>
              </el-form-item>
              <el-form-item label="检测频率：">
                <span>{{rate?(rate+'天'):'未设置'}}</span>
              </el-form-item>
              <el-form-item label="信息提醒：">
                <span>{{warnType_text()}}</span>
              </el-form-item>
            </el-form>
        </div>
      </el-col>
    </el-row>

    <!--dialog 新增-->
    <el-dialog title="设置库存自动检测" :visible.sync="addDialogVisible" class="mydialog mydialog_add_order_group" :append-to-body="true">
      <p class="subtitle">基本设置</p>
      <hr>
      <el-form :label-position="'right'" label-width="120px">
        <el-form-item label="库存自动检测：">
          <el-switch
            active-color="#13ce66"
            inactive-color="#ff4949" v-model="autoCheck">
          </el-switch>
        </el-form-item>
        <el-form-item label="接收汇报结果：">
          <el-checkbox-group v-model="receiveResult">
            <el-checkbox v-for="(item,item_idx) in data_ReceiveResult"
                          :key="item_idx"
                          :label="item.code">{{item.value}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <p class="subtitle">规则设置</p>
      <hr>
      <el-form :label-position="'right'" label-width="120px">
        <el-form-item label="检测范围：">
          <el-radio-group v-model="scope">
            <el-radio v-for="(item,item_idx) in data_Scope"
                          :key="item_idx"
                          :label="item.code">{{item.value}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="检测频率：">
          <el-select size="small" v-model="rate">
            <el-option v-for="n in 30" :key="n" :label="n+'天'" :value="n"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="信息提醒：">
          <el-select size="small" v-model="warnType">
            <el-option  v-for="(item,item_idx) in data_WarnType"
                          :key="item_idx"
                          :label="item.value" :value="item.code"></el-option>
          </el-select>
          <span></span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button class="mybtn-blue2" @click="saveConfig()">保存</el-button>
        <el-button @click="addDialogVisible=false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data: function () {
        return {
            addDialogVisible: false,
            // 下拉框等数据
            data_ReceiveResult:[],
            data_Scope:[],
            data_WarnType:[],
            // 设置
            "autoCheck": false,
            "receiveResult": [],
            "scope": '',
            "rate": '',
            "warnType": '',
            // 展示结果
            receiveResult_text: function(){
                let res = [];
                for(let i=0;i<this.data_ReceiveResult.length;i++){
                    let obj = this.data_ReceiveResult[i];
                    if(this.receiveResult.indexOf(obj.code)!=-1){
                        res.push(obj.value)
                    }
                }
                return res.length ? ('《'+res.join('》《')+'》') : '未设置';
            },
            scope_text: function(){
                for(let i=0;i<this.data_Scope.length;i++){
                    if(this.data_Scope[i].code == this.scope){
                        return this.data_Scope[i].value;
                    }
                }
                return '未设置';
            },
            warnType_text: function(){
                for(let i=0;i<this.data_WarnType.length;i++){
                    if(this.data_WarnType[i].code == this.warnType){
                        return this.data_WarnType[i].value;
                    }
                }
                return '未设置';
            },
        }
    },
    methods:{
        saveConfig: function(){
            let self = this;
            let postData = {
                "autoCheck": self.autoCheck ? 1 : 0,
                "receiveResult": self.receiveResult.join(','),
                "scope": self.scope,
                "rate": self.rate,
                "warnType": self.warnType
            };

            if(postData.autoCheck==1){
                if(!postData.receiveResult){
                    self.xEui.msg_error('请选择接收汇报结果')
                    return;
                }
                if(!postData.scope){
                    self.xEui.msg_error('请选择检测范围')
                    return;
                }
                if(!postData.rate){
                    self.xEui.msg_error('请选择检测频率')
                    return;
                }
                if(!postData.warnType){
                    self.xEui.msg_error('请选择信息提醒方式')
                    return;
                }
            }

            self.xEui.myloading('保存中...')
            self.xFetch.post(self.xApi('/robot/rule/stockautocheck/saveConfig'),postData ).then(function (res) {
                self.xEui.loading_close();
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                }
                else{
                    self.xEui.msg_success('保存成功')
                    self.addDialogVisible = false;
                }
            });
        }
    },
    created: function(){
        let self = this;
        // 下拉框等数据
        self.xFetch.post(self.xApi('/robot/rule/stockautocheck/getReceiveResult'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_ReceiveResult = res.data.data;
        });
        self.xFetch.post(self.xApi('/robot/rule/stockautocheck/getScope'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_Scope = res.data.data;
        });
        self.xFetch.post(self.xApi('/robot/rule/stockautocheck/getWarnType'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_WarnType = res.data.data;
        });

        // 加载设置
        self.xFetch.post(self.xApi('/robot/rule/stockautocheck/getConfig'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            let d = res.data.data || { };
            self.autoCheck = d.autoCheck == 1 ? true : false;
            self.receiveResult = d.receiveResult ? d.receiveResult.split(',') : [];
            self.scope = d.scope;
            self.rate = d.rate;
            self.warnType = d.warnType;
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  hr{
    margin: 20px 0;
    height:1px;
    border:none;
    border-top:1px solid #eeeeee;
  }
  .subtitle{
    font-size: 16px;
    font-weight: bold;
    margin-right: 20px;
  }
  /*mydialog_add_order_group*/
  .mydialog_add_order_group{ }
  .mydialog_add_order_group .dg-input{ width: 220px }
  .mydialog_add_order_group .dg-desc{ font-size: 13px;color: #909399;line-height: 30px }
</style>
<style>
  /*mydialog_add_order_group*/
  .mydialog_add_order_group .el-dialog__body{ padding: 20px;padding-bottom: 0 }
  .mydialog_add_order_group .el-form-item{ margin-bottom: 10px }
</style>



// WEBPACK FOOTER //
// src/views/config/strategy/stock-rule.vue